module.exports = __webpack_public_path__ + "img/predictions.cc733664.svg";